"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONSUMER_ROLE = exports.AGENT_ROLE = exports.SCHEDULING_VISIBILITY_CONSUMER = exports.SCHEDULING_VISIBILITY_AGENT = void 0;
exports.SCHEDULING_VISIBILITY_AGENT = 'agent:direct_book';
exports.SCHEDULING_VISIBILITY_CONSUMER = 'consumer:direct_book';
exports.AGENT_ROLE = 'agent';
exports.CONSUMER_ROLE = 'consumer';
//# sourceMappingURL=Visibility.js.map